
import RouterPage from './home/Routerpage';
import * as React from 'react'
import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client with optimized cache settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes default
      gcTime: 30 * 60 * 1000, // 30 minutes garbage collection time (formerly cacheTime)
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <RouterPage />
      </div>
    </QueryClientProvider>
  );
}

export default App;